import NotificationBase, { onMessageHandler } from './NotificationBase';

export class EmptyNotification extends NotificationBase {
  async requestPermission() {
    return 'default' as const;
  }

  async requestToken() {
    return null;
  }

  async onMessage(handler: onMessageHandler) {
    return () => {};
  }
  onNotificationClick(handler: onMessageHandler) {
    return () => {};
  }

  setBadgeCount() {}
  async getPermissionState() {
    return 'default' as const;
  }

  async clearNotificationsByChannel(channelId: string): Promise<void> {
    // noop
  }

  async clearAllNotifications(): Promise<void> {
    // noop
  }

  supportsNotifications(): boolean {
    return false;
  }

  setActiveChannel(): void {
    // noop
  }
}

export default EmptyNotification;
